import React from 'react';
import { Circle, G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { CoilSymbol } from '../primitives/CoilSymbol';
import { DT } from '../tokens';

/** Coil ΔP — water-side pressure drop across a hydronic coil with P&T ports. */
export function DiagramCoilDeltaP() {
  const cy = 130;

  return (
    <DiagramCanvas>
      {/* Inlet pipe (left) */}
      <Line x1={20} y1={cy} x2={100} y2={cy} stroke={DT.stroke} strokeWidth="9" strokeLinecap="square" />
      {/* Pipe insulation hatch */}
      {[35, 50, 65, 80].map((px) => (
        <Line key={px} x1={px} y1={cy - 5} x2={px + 4} y2={cy + 5} stroke={DT.dim} strokeWidth="0.6" opacity={0.5} />
      ))}
      <Polygon points={`92,${cy} 84,${cy - 4} 84,${cy + 4}`} fill={DT.arrow} />

      {/* Coil body */}
      <Rect x={100} y={70} width={150} height={120} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" rx="3" />
      {/* Fins */}
      {Array.from({ length: 18 }).map((_, i) => (
        <Line key={i} x1={104 + i * 8} y1={72} x2={104 + i * 8} y2={188}
          stroke={DT.stroke} strokeWidth="0.6" opacity={0.5} />
      ))}
      {/* Tubes (serpentine) */}
      <CoilSymbol x={102} y={86} width={146} height={88} loops={4} />

      {/* Outlet pipe */}
      <Line x1={250} y1={cy} x2={330} y2={cy} stroke={DT.stroke} strokeWidth="9" strokeLinecap="square" />
      {[260, 275, 290, 305].map((px) => (
        <Line key={px} x1={px} y1={cy - 5} x2={px + 4} y2={cy + 5} stroke={DT.dim} strokeWidth="0.6" opacity={0.5} />
      ))}
      <Polygon points={`325,${cy} 317,${cy - 4} 317,${cy + 4}`} fill={DT.arrow} />

      {/* P/T ports inlet & outlet */}
      <Line x1={70} y1={cy - 5} x2={70} y2={40} stroke={DT.leader} strokeWidth="1.2" />
      <Circle cx={70} cy={30} r={10} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <Line x1={70} y1={30} x2={64} y2={24} stroke={DT.varColor} strokeWidth="1.5" />
      <SvgText x={70} y={18} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">P₁</SvgText>

      <Line x1={285} y1={cy - 5} x2={285} y2={40} stroke={DT.leader} strokeWidth="1.2" />
      <Circle cx={285} cy={30} r={10} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <Line x1={285} y1={30} x2={290} y2={26} stroke={DT.varColor} strokeWidth="1.5" />
      <SvgText x={285} y={18} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">P₂</SvgText>

      {/* ΔP arrow between gauges */}
      <Line x1={80} y1={50} x2={275} y2={50} stroke={DT.varColor} strokeWidth="1" />
      <Polygon points={`80,50 86,53 86,47`} fill={DT.varColor} />
      <Polygon points={`275,50 269,53 269,47`} fill={DT.varColor} />
      <SvgText x={177} y={46} fill={DT.varColor} fontSize="10" fontFamily={DT.mono} fontWeight="700" textAnchor="middle">ΔP</SvgText>

      {/* Labels */}
      <LeaderLine x1={50} y1={cy - 5} x2={20} y2={210} varName="GPM" desc="water flow" anchor="start" />
      <LeaderLine x1={177} y1={188} x2={170} y2={210} varName="coil" desc="hydronic" anchor="middle" />
      <LeaderLine x1={310} y1={cy - 5} x2={310} y2={210} varName="ΔP" desc="ft H₂O / PSI" anchor="end" />

      <FormulaTag formula="ΔP_coil = P₁ − P₂   (water-side, ft H₂O)" />
    </DiagramCanvas>
  );
}
